module.exports = __webpack_public_path__ + "static/media/cram_pr.067bde4b.webp";